import { __rest } from "tslib";
import React, { useEffect, useState } from 'react';
import { default as replaceStringPlaceholders } from "@pb/utils/replaceStringPlaceholders";
import Markup from "../../helpers/Markup";
const ONE_SEC_IN_MS = 1000;
const Countdown = (_a) => {
    var { expiresAt, countdownTranslatedText = '', className, showDays, showHours, showMinutes, showSeconds, hideOnEnd, onEnd, wrapperClassName, WrapperTag = 'div', children } = _a, props = __rest(_a, ["expiresAt", "countdownTranslatedText", "className", "showDays", "showHours", "showMinutes", "showSeconds", "hideOnEnd", "onEnd", "wrapperClassName", "WrapperTag", "children"]);
    const [currentTimestamp, setCurrentTimestamp] = useState(Date.now());
    const [expireTimestamp, setExpireTimestamp] = useState(expiresAt);
    useEffect(() => {
        let updateInterval;
        if (expireTimestamp - currentTimestamp >= 0) {
            updateInterval = window.setInterval(() => setCurrentTimestamp(currentTimestamp + ONE_SEC_IN_MS), ONE_SEC_IN_MS);
        }
        return () => {
            clearInterval(updateInterval);
        };
    }, [expireTimestamp, currentTimestamp]);
    useEffect(() => {
        setExpireTimestamp(expiresAt);
        setCurrentTimestamp(Date.now());
    }, [expiresAt]);
    const deadline = expiresAt - currentTimestamp;
    const isExpired = deadline <= 0;
    useEffect(() => {
        if (isExpired && onEnd) {
            onEnd();
        }
    }, [isExpired, onEnd]);
    const daysLeft = isExpired ? 0 : Math.floor(deadline / (ONE_SEC_IN_MS * 60 * 60 * 24));
    const hoursLeft = isExpired
        ? 0
        : Math.floor((deadline % (ONE_SEC_IN_MS * 60 * 60 * 24)) / (ONE_SEC_IN_MS * 60 * 60));
    const minutesLeft = isExpired
        ? 0
        : Math.floor((deadline % (ONE_SEC_IN_MS * 60 * 60)) / (ONE_SEC_IN_MS * 60));
    const secondsLeft = isExpired ? 0 : Math.floor((deadline % (ONE_SEC_IN_MS * 60)) / ONE_SEC_IN_MS);
    const timeLeft = {
        days: daysLeft.toString().padStart(2, '0'),
        hours: hoursLeft.toString().padStart(2, '0'),
        minutes: minutesLeft.toString().padStart(2, '0'),
        seconds: secondsLeft.toString().padStart(2, '0'),
    };
    const replacements = [
        ...(showDays ? [timeLeft.days] : []),
        ...(showHours ? [timeLeft.hours] : []),
        ...(showMinutes ? [timeLeft.minutes] : []),
        ...(showSeconds ? [timeLeft.seconds] : []),
    ];
    return (React.createElement(WrapperTag, Object.assign({ role: "timer", "aria-live": "off", className: wrapperClassName }, props), !(isExpired && hideOnEnd) &&
        (children ? (React.Children.map(children, (child) => React.isValidElement(child) &&
            timeLeft[child.props.type] !== undefined
            ? React.cloneElement(child, { value: timeLeft[child.props.type] }, null)
            : null)) : (React.createElement(Markup, Object.assign({ Tag: "time", className: className }, { dateTime: new Date(expiresAt).toISOString() }, { input: replaceStringPlaceholders(countdownTranslatedText, replacements) }))))));
};
export default Countdown;
//# sourceMappingURL=Countdown.js.map